export const DESIGN_07 = {
 "blocks": [
    {
      "blockType": "NAVBAR",
      "blockDesign": "NavDesign1",
      "editFormName": "NAVBAR_FORM_1",
      "styleProps": {
        "background-color": "#F7F7F8",
        "padding": "10px 0px 10px 0px"
      },
      "logoType": "text",
      "logoImg": {
        "src": "https://freshflowxyz.b-cdn.net/assets/logo/FlexBee-Logo-1.jpg",
        "altText": "FlexBee",
        "styleProps": {
          "height": "3rem"
        }
      },
      "logoText": {
        "text": "꩜ Onic",
        "styleProps": {
          "font-size": "1.875rem",
          "color": "#333333",
          "font-family": "'Lato', sans-serif",
          "line-height": "2.25rem",
          "font-family-bk": "'Lato', sans-serif",
          "font-weight": "900"
        },
        "stylePropsMob": {},
        "stylePropsTab": {}
      },
      "logoHTML": {
        "html": "FlexBee",
        "styleProps": {
          "font-size": "1.875rem",
          "color": "#ffffff",
          "font-family": "'Oswald', sans-serif",
          "line-height": "2.25rem"
        },
        "stylePropsMob": {},
        "stylePropsTab": {}
      },
      "links": [
        {
          "text": "Features",
          "linkUrl": "/features",
          "styleProps": {
            "color": "",
            "padding": "14px 34px 14px 34px",
            "margin": "0px 0px 0px 0px"
          },
          "sectionID": "aboutsection"
        },
        {
          "text": "Services",
          "linkUrl": "/services",
          "styleProps": {
            "color": "",
            "padding": "14px 34px 14px 34px",
            "margin": "0px 0px 0px 0px"
          },
          "sectionID": "aboutsection"
        },
        {
          "text": "Docs",
          "linkUrl": "/docs",
          "styleProps": {
            "color": "",
            "padding": "14px 34px 14px 34px",
            "margin": "0px 0px 0px 0px"
          },
          "sectionID": "aboutsection"
        },
        {
          "text": "Pricing",
          "linkUrl": "/pricing",
          "sectionID": "aboutsection",
          "styleProps": {
            "color": "",
            "padding": "14px 34px 14px 34px",
            "margin": "0px 0px 0px 120px"
          }
        },
        {
          "text": "Get Started",
          "linkUrl": "/home",
          "sectionID": "aboutsection",
          "styleProps": {
            "color": "#ffffff",
            "border-width": "0px",
            "border-radius": "1rem",
            "padding": "14px 30px 14px 30px",
            "margin": "0px 0px 0px 20px",
            "border-color": "#4f4f4f",
            "background-color": "",
            "background-image": "linear-gradient(to left,#644fb3,#644fb3)"
          }
        }
      ],
      "hamburgerStyleProps": {
        "color": "#333333",
        "border-color": "#333333"
      },
      "metaDataId": 1748054051706,
      "afterIndex": 1,
      "blockId": 1748054051706,
      "linksStyleProps": {
        "color": "#333333",
        "padding": "14px 0px 14px 0px",
        "font-weight": "500",
        "font-size": "1.125rem",
        "line-height": "1.75rem"
      }
    },
    {
      "blockType": "ELEMENTS",
      "blockDesign": "ImageElement",
      "editFormName": "IMAGE_ELEMENT_FORM",
      "styleProps": {
        "background-color": "",
        "background-image": "linear-gradient(to bottom,#8550ab,#644fb3)",
        "padding": "60px 0px 10px 0px"
      },
      "stylePropsTab": {},
      "stylePropsMob": {},
      "imagesPerRow": {
        "desktop": 1
      },
      "images": {
        "styleProps": {
          "background-image": "url('')",
          "padding": "20px 160px 20px 160px",
          "border-radius": "1rem",
          "max-width": "768px",
          "background-color": "#000000",
          "box-shadow": "0 25px 50px -12px rgb(0 0 0 / 0.25)"
        },
        "stylePropsTab": {
          "padding": "10px 20px 10px 20px"
        },
        "stylePropsMob": {
          "padding": "10px 10px 10px 10px"
        },
        "list": [
          {
            "url": "{{img}}",
            "alt": "profile image",
            "styleProps": {
              "justify-content": "left"
            },
            "innerDivStyle": {
              "width": "100%",
              "border-radius": "1.5rem"
            },
            "innerDivStyleTab": {
              "width": "50%"
            },
            "innerDivStyleMob": {
              "width": "100%"
            }
          }
        ]
      },
      "metaDataId": 1747663311614,
      "afterIndex": -1,
      "blockId": 1747663311614
    },
    {
      "temp": {
        "templateId": 20
      },
      "blockType": "HEADER",
      "blockDesign": "HeaderDesign2",
      "editFormName": "HEADER_04_FORM",
      "styleProps": {
        "background-image": "linear-gradient(to bottom,#644fb3,#8550ab)",
        "background-color": "",
        "padding": "10px 20px 60px 20px",
        "border-width": "0px",
        "border-color": "#cccccc"
      },
      "textBlock": {
        "styleProps": {
          "background-color": "",
          "border-radius": "0",
          "padding": "10px 20px 10px 20px"
        },
        "stylePropsTab": {
          "padding": "0px 0px 0px 0px"
        },
        "stylePropsMob": {},
        "alingBlock": "start",
        "headings": [
          {
            "text": "{{name}}",
            "hideUnderline": false,
            "underLineStyle": {
              "background-color": "red",
              "height": "1px"
            },
            "styleProps": {
              "color": "#333333",
              "font-size": "3.75rem",
              "line-height": "1",
              "font-family": "",
              "font-weight": "400",
              "font-family-cust": "",
              "font-family-bk": "'Lato', sans-serif"
            },
            "alignStyleProps": {
              "text-align": "left",
              "padding": "10px 0px 10px 0px",
              "margin": "10px 0px 0px 0px"
            },
            "stylePropsMob": {
              "font-size": "3rem",
              "line-height": "1"
            },
            "stylePropsTab": {
              "font-size": "3.75rem",
              "line-height": "1"
            }
          },
          {
            "text": "{{role}}",
            "hideUnderline": false,
            "underLineStyle": {
              "background-color": "red",
              "height": "1px"
            },
            "styleProps": {
              "color": "#333333",
              "font-size": "1.5rem",
              "line-height": "2rem",
              "font-family": "",
              "font-weight": "400"
            },
            "alignStyleProps": {
              "text-align": "left",
              "margin": "10px 0px 0px 0px",
              "padding": "10px 0px 10px 0px"
            }
          },
          {
            "text": "{{content}}",
            "hideUnderline": false,
            "underLineStyle": {
              "background-color": "yellow",
              "height": "2px"
            },
            "styleProps": {
              "color": "#333333",
              "font-size": "1.125rem",
              "line-height": "1.75rem"
            },
            "alignStyleProps": {
              "text-align": "left",
              "margin": "10px 0px 10px 0px",
              "padding": "10px 0px 10px 0px"
            }
          }
        ],
        "dynamicText": {
          "styleProps": {
            "color": "#ffffff",
            "font-size": "1.875rem",
            "line-height": "2.25rem",
            "padding": "10px 0px 10px 0px",
            "text-align": "center"
          },
          "stylePropsTab": {
            "padding": "10px 0px 10px 0px",
            "font-size": "1.5rem",
            "line-height": "2rem"
          },
          "stylePropsMob": {
            "padding": "10px 0px 10px 0px",
            "font-size": "1.5rem",
            "line-height": "2rem"
          },
          "strings": []
        },
        "descriptionsStyleProps": {
          "padding": "10px 0px 10px 0px",
          "text-align": "center",
          "margin": "0px 0px 0px 0px"
        },
        "descriptionsStylePropsTab": {
          "padding": "10px 0px 10px 0px"
        },
        "descriptionsStylePropsMob": {
          "padding": "10px 0px 10px 0px"
        },
        "descriptions": [],
        "buttonsStyleProps": {
          "margin": "50px 0px 0px 0px",
          "padding": "0px 0px 0px 0px"
        },
        "buttonAlign": "start",
        "buttons": [],
        "emailSecStyleProps": {},
        "subscription": {
          "showSection": "hide",
          "display": "enable",
          "subConfigs": {
            "configType": "convertkit",
            "configUrl": "https://app.convertkit.com/forms/xxxxxx/subscriptions",
            "configPlaceholder": ""
          },
          "email_placeholder": {
            "text": "example@mail.com"
          },
          "buttonText": {
            "text": "Subscribe",
            "styleProps": {
              "background-color": "#1b1b31",
              "color": "#ffffff"
            }
          },
          "successMessage": {
            "text": "Thank you for the signup",
            "styleProps": {}
          },
          "errorMessage": {
            "text": "Something went wrong. Please try again.",
            "styleProps": {}
          }
        },
        "buttonsStylePropsTab": {
          "padding": "0px 0px 0px 0px"
        }
      },
      "imageType": "image",
      "imageVideoPostion": "left",
      "imageBlock": {
        "image": "",
        "styleProps": {
          "margin": "20px 20px 20px 20px",
          "border-radius": "0px"
        },
        "outerStyleProps": {
          "border-radius": "0px"
        },
        "tagStyleProps": {
          "border-radius": "0px"
        }
      },
      "videoBlock": {
        "url": "https://www.youtube.com/watch?v=tKR58TIaJ9k",
        "styleProps": {
          "margin": "20px 20px 20px 20px"
        },
        "videoHeight": {
          "height": "400px"
        }
      },
      "htmlBlock": {
        "value": "",
        "styleProps": {}
      },
      "metaDataId": 1747662435564,
      "blockId": 1747662435564,
      "buttons": [
        {
          "text": "Click Here",
          "styleProps": {
            "color": "#ffffff",
            "border-color": "#3b82f680"
          },
          "href": "#",
          "openType": "sametab"
        }
      ],
      "fonts": {
        "textBlock": ""
      },
      "position": "hide",
      "stylePropsTab": {
        "padding": "40px 20px 40px 20px"
      },
      "stylePropsMob": {
        "padding": "30px 20px 30px 20px"
      },
      "containerStyleProps": {
        "background-color": "#ffffff",
        "border-radius": "1rem",
        "padding": "60px 60px 60px 60px",
        "max-width": "768px",
        "box-shadow": "0 25px 50px -12px rgb(0 0 0 / 0.25)"
      },
      "afterIndex": -1
    },
    {
      "blockType": "CTA",
      "blockDesign": "CTADesign1",
      "editFormName": "CTA_01_FORM",
      "styleProps": {
        "background-color": "#ffffff",
        "padding": "120px 20px 120px 20px",
        "background-image": "linear-gradient(to bottom,,)"
      },
      "headings": [
        {
          "text": "☆ Top 10 from over 100+ developers",
          "styleProps": {
            "text-align": "center",
            "font-size": "1.25rem",
            "line-height": "1.75rem",
            "padding": "10px 30px 10px 30px",
            "color": "#333333",
            "font-family-cust": "",
            "font-family": "'Open Sans', sans-serif",
            "font-family-bk": "'Open Sans', sans-serif",
            "font-weight": "900",
            "border-width": "1px",
            "border-color": "#12121211",
            "border-radius": "1rem"
          },
          "alignStyleProps": {
            "text-align": "center"
          },
          "stylePropsTab": {
            "font-size": "3rem",
            "line-height": "1"
          },
          "stylePropsMob": {
            "font-size": "2.25rem",
            "line-height": "2.5rem"
          }
        },
        {
          "text": "Explore More Top Developers",
          "styleProps": {
            "text-align": "center",
            "padding": "20px 0px 30px 0px",
            "color": "#333333",
            "font-size": "4.5rem",
            "line-height": "1",
            "font-family": "'Open Sans', sans-serif",
            "font-weight": "400"
          },
          "alignStyleProps": {
            "text-align": "center"
          },
          "stylePropsTab": {
            "font-size": "3rem",
            "line-height": "1"
          },
          "stylePropsMob": {
            "font-size": "1.875rem",
            "line-height": "2.25rem"
          }
        }
      ],
      "showBtnSec": true,
      "btnSecStyleProps": {
        "justify-content": "center",
        "padding": "40px 0px 0px 0px"
      },
      "btnSecStylePropsTab": {},
      "btnSecStylePropsMob": {},
      "buttons": [
        {
          "text": "➤ View More Developers",
          "alt": "Click Here",
          "href": "https://yahoo.com",
          "styleProps": {
            "background-color": "#0E0F10",
            "color": "#ffffff",
            "border-color": "#3b82f680",
            "border-radius": "1rem",
            "padding": "18px 40px 18px 40px",
            "border-width": "0px"
          },
          "openType": "sametab"
        },
        {
          "text": "Explore Our Talent Pool",
          "styleProps": {
            "color": "#333333",
            "border-color": "#3b82f680",
            "background-color": "",
            "border-width": "0px",
            "border-radius": "1rem",
            "padding": "18px 40px 18px 40px"
          },
          "href": "",
          "openType": "sametab"
        }
      ],
      "showEmailSec": true,
      "emailSecStyleProps": {},
      "subscription": {
        "showSection": "hide",
        "display": "enable",
        "subConfigs": {
          "configType": "convertkit",
          "configUrl": "https://app.convertkit.com/forms/xxxxxx/subscriptions",
          "configPlaceholder": ""
        },
        "email_placeholder": {
          "text": "example@mail.com"
        },
        "buttonText": {
          "text": "Subscribe",
          "styleProps": {
            "background-color": "#1b1b31",
            "color": "#ffffff"
          }
        },
        "successMessage": {
          "text": "Thank you for the signup",
          "styleProps": {}
        },
        "errorMessage": {
          "text": "Something went wrong. Please try again.",
          "styleProps": {}
        }
      },
      "metaDataId": 1747663920462,
      "afterIndex": -1,
      "blockId": 1747663920462,
      "containerStyleProps": {
        "padding": "0px 0px 0px 0px",
        "max-width": "896px"
      },
      "containerStylePropsTab": {
        "padding": "0px 0px 0px 0px"
      },
      "fonts": {
        "headings": [
          ""
        ]
      },
      "stylePropsTab": {
        "padding": "80px 20px 80px 20px"
      },
      "stylePropsMob": {
        "padding": "60px 20px 60px 20px"
      }
    }
  ]
}